import { Box, Typography } from '@mui/material';
import FormsPopup from '../../common/FormsPopup/FormsPopup';
import InputField from '../../common/InputField/InputField';
import CustomSelect from '../../common/Select';
import styles from './styles';
import { CreateAdminProps } from './types';
import FormButton from '../../common/FormButton';

const CreateAdmin = ({
    open,
    handleInput,
    roles,
    selectedRoleId = '',
    handleSubmit,
    handleCloseCreatePop,
    formValues,
    formErrors,
    submitting,
}: CreateAdminProps) => {
    return (
        <FormsPopup
            id="create_new_admin_popup"
            open={open}
            title="Create New Admin"
            textAlign="left"
            handleClose={handleCloseCreatePop}
            description={
                <>
                    To complete the new admin's registration, please add their credentials to your password manager, and
                    allow them to log in utilizing that tool. Passwords must have 8 characters. including one capital
                    letter, special character and number.
                </>
            }
            width={474}
        >
            <Box component="form" noValidate onSubmit={handleSubmit}>
                <InputField
                    required
                    id="firstname"
                    label="First Name*"
                    type="text"
                    name="firstname"
                    placeholder="E.g. Marcos"
                    onChange={handleInput}
                    error={formErrors && formErrors.firstname && formErrors.firstname[0] !== ''}
                    errorMessage={formErrors && formErrors.firstname && formErrors.firstname[0]}
                />
                <Typography
                    component="div"
                    sx={{
                        mt: '24px',
                    }}
                >
                    <InputField
                        required
                        id="lastname"
                        label="Last Name*"
                        type="text"
                        name="lastname"
                        placeholder="E.g. Castro"
                        onChange={handleInput}
                        error={formErrors && formErrors.lastname && formErrors.lastname[0] !== ''}
                        errorMessage={formErrors && formErrors.lastname && formErrors.lastname[0]}
                    />
                </Typography>
                <Typography
                    component="div"
                    sx={{
                        mt: '24px',
                    }}
                >
                    <CustomSelect
                        name="roleId"
                        label="Role*"
                        id="roleId"
                        handleOnchange={handleInput}
                        items={roles}
                        value={selectedRoleId}
                        error={formErrors && formErrors.roleId && formErrors.roleId[0] !== ''}
                        errorMessage={formErrors && formErrors.roleId && formErrors.roleId[0]}
                    />
                </Typography>

                <Typography
                    component="div"
                    sx={{
                        mt: '24px',
                    }}
                >
                    <InputField
                        required
                        name="email"
                        label="Email*"
                        type="text"
                        id="email"
                        placeholder="@email.com"
                        autoComplete="Email"
                        value={formValues?.email}
                        onChange={handleInput}
                        error={formErrors && formErrors.email && formErrors.email[0] !== ''}
                        errorMessage={formErrors && formErrors.email && formErrors.email[0]}
                    />
                </Typography>

                <Typography
                    component="div"
                    sx={{
                        mt: '24px',
                    }}
                >
                    <InputField
                        required
                        name="password"
                        label="Create Password*"
                        type="password"
                        id="password"
                        placeholder="Type here..."
                        autoComplete="Create Password"
                        value={formValues?.password}
                        onChange={handleInput}
                        error={formErrors && formErrors.password && formErrors.password[0] !== ''}
                        errorMessage={formErrors && formErrors.password && formErrors.password[0]}
                    />
                </Typography>
                <FormButton
                    id="save_admin"
                    type="submit"
                    fullWidth
                    variant="contained"
                    sx={styles.button}
                    submitting={submitting}
                >
                    Save Admin
                </FormButton>
            </Box>
        </FormsPopup>
    );
};

export default CreateAdmin;
